import { Component } from '@angular/core';
import {
  KillSwitchService,
  VersionInfo,
} from 'src/app/services/kill-switch.service';

@Component({
  selector: 'app-kill-switch',
  templateUrl: './kill-switch.component.html',
  styleUrls: ['./kill-switch.component.scss'],
})
export class KillSwitchComponent {
  loading: boolean = false;
  killAllOptions: { label: string; value: string }[] = [
    { label: 'Enable All', value: 'false' },
    { label: 'Disable All', value: 'true' },
  ];

  versionInfo?: VersionInfo;

  killAll = '';
  killAllTitle = '';
  killAllMessage = '';
  killAllLink = '';
  minVersion = '';
  minVersionTitle = '';
  minVersionMessage = '';
  minVersionLink = '';

  errorUpdating = '';

  constructor(private killSwitchService: KillSwitchService) {}

  ngOnInit() {
    this.getKillSwitchInfo();
  }

  async getKillSwitchInfo() {
    this.loading = true;
    this.killSwitchService.getKillSwitchInfo().subscribe({
      next: (response) => {
        this.loading = false;
        console.log('Kill switch info fetched successfully', response);

        this.versionInfo = response.version_info;

        this.killAll = this.versionInfo.kill_all.toString();
        this.killAllTitle = this.versionInfo.kill_all_title;
        this.killAllMessage = this.versionInfo.kill_all_message;
        this.killAllLink = this.versionInfo.kill_all_link;
        this.minVersion = this.versionInfo.min_version;
        this.minVersionTitle = this.versionInfo.min_version_title;
        this.minVersionMessage = this.versionInfo.min_version_message;
        this.minVersionLink = this.versionInfo.min_version_link;
      },
      error: (error) => {
        this.loading = false;
        console.error(new Error(error));
      },
    });
  }

  validateInputs() {
    if (!this.killAllTitle) {
      this.errorUpdating = 'Please enter a kill all title';
      return false;
    }

    if (!this.killAllMessage) {
      this.errorUpdating = 'Please enter a kill all message';
      return false;
    }

    if (!this.killAllLink) {
      this.errorUpdating = 'Please enter a kill all link';
      return false;
    }

    if (!this.minVersion) {
      this.errorUpdating = 'Please enter a min version';
      return false;
    }

    if (!this.minVersionTitle) {
      this.errorUpdating = 'Please enter a min version title';
      return false;
    }

    if (!this.minVersionMessage) {
      this.errorUpdating = 'Please enter a min version message';
      return false;
    }

    if (!this.minVersionLink) {
      this.errorUpdating = 'Please enter a min version link';
      return false;
    }

    return true;
  }

  updateKillSwitchInfo() {
    this.loading = false;
    this.errorUpdating = '';
    if (!this.validateInputs()) {
      return;
    }

    this.loading = true;
    const killSwitchRequest = {
      kill_all: this.killAll === 'true' ? true : false,
      kill_all_title: this.killAllTitle,
      kill_all_message: this.killAllMessage,
      kill_all_link: this.killAllLink,
      min_version: this.minVersion,
      min_version_title: this.minVersionTitle,
      min_version_message: this.minVersionMessage,
      min_version_link: this.minVersionLink,
    };
    console.log('Updating kill switch with', killSwitchRequest);

    this.killSwitchService.updateKillSwitchInfo(killSwitchRequest).subscribe({
      next: (response) => {
        this.loading = false;
        console.log('Kill switch updated successfully', response);
        this.versionInfo = response.version_info;
      },
      error: (error) => {
        this.loading = false;
        console.error(new Error(error));
      },
    });
  }
}
